import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { isDeleteCommentConfirmationModalOpenAtom } from "Shared/Components/Comments/Atom/isDeleteConfirmationModalOpen";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import type { UseMutationResult } from "@tanstack/react-query";
import { useAtom } from "jotai";
import type { FC } from "react";

type CommentDeleteConfirmationModalProps = {
	commentId: number;
	closeEdit: () => void;
	deleteCommentMutation: UseMutationResult<void, Error, number, unknown>;
};

const commentResource = Resources.base.comment.shared.confirmationModal;

export const CommentDeleteConfirmationModal: FC<
	CommentDeleteConfirmationModalProps
> = ({ commentId, deleteCommentMutation }) => {
	const { t } = useResource();
	const { mutate: deleteComment, isPending } = deleteCommentMutation;
	const [currentModalOpen, setCurrentModalOpen] = useAtom(
		isDeleteCommentConfirmationModalOpenAtom,
	);

	const handleDeleteComment = () => {
		deleteComment(commentId);
		setCurrentModalOpen(null);
	};

	return (
		<Dialog open={!!currentModalOpen} onClose={() => setCurrentModalOpen(null)}>
			<DialogTitle>{t(commentResource.title)}</DialogTitle>
			<DialogContent>{t(commentResource.message)}</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={() => setCurrentModalOpen(null)}>
					{t(commentResource.cancel)}
				</Button>
				<Button
					variant="contained"
					onClick={handleDeleteComment}
					loading={isPending}
				>
					{t(commentResource.delete)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
